import { render, staticRenderFns } from "./InvoiceReceipt.vue?vue&type=template&id=65c457de&"
import script from "./InvoiceReceipt.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c457de')) {
      api.createRecord('65c457de', component.options)
    } else {
      api.reload('65c457de', component.options)
    }
    module.hot.accept("./InvoiceReceipt.vue?vue&type=template&id=65c457de&", function () {
      api.rerender('65c457de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/InvoiceReceipt.vue"
export default component.exports